.time-col {
  position: relative;
  box-sizing: border-box;
  width: var(--rc-calendar-hour-width);
  border-right: var(--rc-calendar-border-base);

  &::after {
    position: absolute;
    top: 0;
    right: 0;
    width: var(--rc-calendar-extra-line-width);
    height: 1px;
    background-color: var(--rc-calendar-color-border-default);
    content: ' ';
  }

  .time-text {
    position: absolute;
    top: 0;
    left: 0;
    width: calc(var(--rc-calendar-hour-width) - var(--rc-calendar-extra-line-width) - 4px);
    transform: translateY(-50%);
    color: var(--rc-calendar-color-text-secondary);
    font-size: var(--rc-calendar-font-size-text-sm);
    text-align: right;
  }
}
